import { render, staticRenderFns } from "./device-kindle.component.vue?vue&type=template&id=20ba8bcb&scoped=true"
import script from "./device-kindle.component.vue?vue&type=script&lang=ts"
export * from "./device-kindle.component.vue?vue&type=script&lang=ts"
import style0 from "./device-kindle.component.vue?vue&type=style&index=0&id=20ba8bcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba8bcb",
  null
  
)

export default component.exports